<template>
  <div class="header-wrapper">
    <img src="../assets/img/header-top-wave.png" class="wave" />
    <div v-show="receive" class="receive-lock" @click="receive = false" >......</div>
    <div v-if="PP" v-show="receive" class="receive-container">
      <div>
        <img class="adorable" :src="avatar">
      </div>
      <div class="qrid-container">
        <div>{{email}}</div>
        <div class="qr">
          <qriously :value="PP" :size="260"/>
        </div>
        <div class="re-note">Have the sender scan this QRCode <br> or send your Account Id</div>
        <label style="width: 100%; margin-left: 10px;" for="account-id">Account Id</label>
        <div class="publickey">
          <div class="account-id-wrapper">
            <el-input v-model="PP" class="account-id"></el-input>
          </div>
          <el-button class="copy" slot="append" type="success" v-clipboard:copy="PP" @click="copy">
            <clipboard-icon></clipboard-icon>
          </el-button>
        </div>
      </div>
    </div>

    <!-- <nav-mobile :isLogin="isLogin" @onClickNavMobile="onClickNavMobile"></nav-mobile> -->

    <div class="home">
      <!--   <img width="30%" src="../assets/img/logo-luxtag.png"> -->
      <img @click="logoClicked" src="../assets/img/logo-luxtag.png" class="logo_lt">
    </div>

    <!-- <div class="menu">
      <el-menu
        class="main-menu"
        v-if="!isLogin"
        :default-active.sync="beforeLoginIndex"
        mode="horizontal"
        background-color="transparent"
        active-text-color="#ffffff"
        text-color="#ffffff"
        font-family: HelveticaNeue
        @select="handleBeforeLoginNav"> -->
        <!-- <el-menu-item class="main-menu-item" index="0">LOGIN</el-menu-item>
        <el-menu-item class="main-menu-item1" index="3">|</el-menu-item>

        <el-menu-item class="main-menu-item" index="1">SIGNUP</el-menu-item> -->
        <!-- <el-menu-item class="main-menu-item" index="2">VERIFY</el-menu-item> -->
      <!-- </el-menu>
      <el-menu
        class="main-menu"
        v-if="isLogin"
        :default-active.sync="afterLoginIndex"
        mode="horizontal"
        background-color="transparent"
        active-text-color="#ffffff"
        text-color="#ffffff"
        @select="handleAfterLoginNav">
        <el-menu-item class="main-menu-item" index="0" >DASHBOARD</el-menu-item>
        <el-submenu class="" index="2">
          <template slot="title">
            <img class="avatar" :src="avatar">
            PROFILE
          </template>
          <el-menu-item class="slidedown-menu" style="background-color: #41A3F7 !important;" index="2-1">{{email}}</el-menu-item>
          <el-menu-item class="slidedown-menu" style="background-color: #41A3F7 !important;" index="2-3">Logout</el-menu-item>
        </el-submenu>
      </el-menu>
    </div> -->
  </div>
</template>

<script>
import { ClipboardIcon } from 'vue-feather-icons';
import iziToast from 'izitoast';
import luxtagApi from '../API/index';
import EventBus from '../Buss/EventBus';

const NavMobile = () => import('./NavMobile');


export default {
  data() {
    return {
      beforeLoginIndex: '-1',
      afterLoginIndex: '0',
      customPanelStyle: {
        background: '#f7f7f7',
        borderRadius: '4px',
        border: 0,
      },
      email: '',
      loading: false,
      active: false,
      receive: false,
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters.getAuth.login;
    },
    PP() {
      return this.$store.getters.getAuth.PP;
    },
    avatar() {
      // return `https://api.adorable.io/avatars/285/${this.$store.getters.getAuth.email}.png`;
      return `https://ui-avatars.com/api/?name=${this.$store.getters.getAuth.email}.png&size=80`;
    },
  },
  methods: {
    onClickNavMobile(key) {
      if (this.isLogin) {
        this.handleAfterLoginNav(key);
      } else {
        this.handleBeforeLoginNav(key);
      }
    },
    logoClicked() {
      this.$router.replace('/dashboard');
    },
    handleBeforeLoginNav(key, keyPath) {
      if (key === '0') {
        // go to the login route with login tab open
        this.$router.push('/login');
      } else if (key === '1') {
        // go to the login route with signup tab open
        this.$router.push('/sign-up');
      } else if (key === '2') {
        // go to the login route with signup tab open
        this.$router.push('/verify');
      }
    },
    handleAfterLoginNav(key, keyPath) {
      if (key === '0') {
        // go to dashboard route
        this.$router.replace('/dashboard');
      } else if (key === '1') {
        // show receive ID
        if (this.active) {
          // if (this.$route.name !== 'Dashboard') {
          // this.$router.replace('/dashboard');
          // }
          this.receive = true;
        } else {
          this.$message({
            message: 'Please activate your account to be able to receive assets',
            type: 'error',
          });
        }
      } else if (key === '2-1') {
        // go to profile route
        this.$router.push('/profile');
      } else if (key === '2-2') {
        // faq
        this.$router.push('/faq');
      } else if (key === '2-3') {
        // logout
        EventBus.$emit('logout');
        this.$router.replace('/');
      }
    },
    copy() {
      this.$message({
        message: 'Copied to clipboard!',
        type: 'success',
        showClose: true,
      });
    },
    changeNavIndex(path) {
      switch (path) {
        case '/login':
          this.beforeLoginIndex = '0';
          break;
        case '/sign-up':
          this.beforeLoginIndex = '1';
          break;
        case '/dashboard':
          this.afterLoginIndex = '0';
          break;
        case '/profile':
          this.afterLoginIndex = '2-1';
          break;
        default:
          if (this.isLogin) {
            this.afterLoginIndex = '-1';
          } else {
            this.beforeLoginIndex = '-1';
          }
      }
    },
  },
  watch: {
    receive() {
      this.afterLoginIndex = '-99';
    },
  },
  components: {
    ClipboardIcon,
    NavMobile,
  },
  created() {
    const that = this;
    if (this.isLogin) {
      this.email = this.$store.getters.getAuth.email;
    }
    EventBus.$on('login', (auth) => {
      that.$store.commit('STORE_AUTH', auth);
      this.email = this.$store.getters.getAccounts[auth.index].name;
    });

    EventBus.$on('home', () => {
      this.$router.replace('/');
    });

    EventBus.$on('logout', () => {
      that.$store.commit('STORE_AUTH', {
        login: false,
      });
    });

    // default index
    this.changeNavIndex(this.$route.fullPath);

    this.$router.beforeEach((to, from, next) => {
      this.changeNavIndex(to.fullPath);
      next();
    });
  },
  mounted() {
    const that = this;
    EventBus.$on('got-account-status', (status) => {
      that.active = status;
      if (status === false) {
        iziToast.destroy();
        iziToast.show({
          title: 'Oups',
          message: 'It seems that you didn\'t verify your account please check your email',
          close: false,
          layout: 2,
          backgroundColor: '#FDF6EC',
          messageColor: '#F7BA2A',
          titleColor: '#F7BA2A',
          transitionIn: 'flipInX',
          transitionOut: 'flipOutX',
          position: 'topCenter',
          timeout: false,
          buttons: [
            ['<button>Resend email</button>', (instance, toast) => {
              luxtagApi.email.accountVerification(that.$store.getters.getAuth.email)
              .then((response) => {
                iziToast.hide(toast);
                this.$message({
                  message: 'Email confirmation has been sent to your email',
                  type: 'success',
                });
              }).catch((e) => {
                this.$message({
                  message: e,
                  type: 'error',
                  showClose: true,
                });
              });
            }, true], // true to focus
          ],
        });
      }
    });
  },
};
</script>

<style lang="scss">
  $nav-height: 100px;
 
  header{
    border: none;
  }
  .el-menu--horizontal {
    border: none !important;
  }
  .header-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    // height: $nav-height;
    align-items: flex-start;
    max-width: 1919px;
    height: 140px;
    margin: 0 auto;
    background-color: transparent;
   // background-color: #1A82D2;
    .menu{
      height: 150px;
    }
    .main-menu{
      margin-right: 40px;
    }
    .main-menu-item{
      margin-top: 0px;
      font-size: 15px;
      margin-right : 1px;
    }

    .home{
      display: flex;
      flex-direction: row;
      color: #000;
      align-items: flex-start;
      justify-content: flex-start;
      align-self: flex-start;
      z-index: 800;
      height: 100px;    
      width: 182px;
      margin-left: 1.65%;
      margin-top: 1.4%;
      img[alt=logo] {
        height: 100%;
        max-height: 91%;
        margin: 0 16px;
      }
      .logo_lt{
        align-items: center;
        justify-content: center;
        width: 41%;
        cursor: pointer;
      }

      .head-logo {
        color: #48576a;
        margin: 0px;
        margin-right: 10px;
        font-weight: bold;
        font-size: 1.6em;
        letter-spacing: 1.5px;
      }

      @media only screen and (max-width: 450px) {
        img[alt=logo] {
          height: 70%;
          max-height: 91%;
          margin: 0 16px;
        }
      }
    }

    .wave {
      top: 0;
      display: flex;
      position: absolute;
      height: 25%;
      width: 100%;
      z-index: -1;
    }

    @media screen and (max-width: 768px) {
      .home {
        align-items: flex-start;
        justify-content: flex-start;
        .logo_lt{
          margin-left: 10%;
          width: 41%;
        }
      }
    }
    @media screen and (max-width: 425px) {
      .home {
        margin-top: 5% !important;
        .logo_lt{
          margin-left: 10%;
          width: 30%;
        }
      }
    }
    @media screen and (max-width: 375px) {
      .home {
        .logo_lt{
          margin-left: 10%;
          width: 30%;
        }
      }
    }
    
    .menu {
      @media only screen and (max-width: 450px)  {
        display: none;
      }
      .main-menu {
        .main-menu-item {
          height: $nav-height - 20px;
          line-height: $nav-height - 20px;
        }
        .main-menu-item:hover {
          background-color: transparent !important;
        }
        .main-menu-item1 {
          height: $nav-height - 20px;
          line-height: $nav-height - 20px;
        }
        .main-menu-item1:hover {
          background-color: transparent !important;
        }
        .is-active {
          background-color: transparent !important;
          border-bottom-color: transparent !important;
        }
        .el-submenu {
          height: $nav-height - 20px;
          .el-submenu__title {
            height: $nav-height - 20px;
            line-height: $nav-height - 20px;
          } 
          .el-submenu__title:hover {
            background-color: #41A3F7 !important;
          }
          .el-menu {
            top:75px;
          }
          .slidedown-menu {
            background-color: #41A3F7 !important;
          }
          .slidedown-menu:hover{
            background-color: #41A3F7 !important;
          }
        }
      }
    }
  }

  @media screen and (max-width: 425px) {
    .header-wrapper {
      height: $nav-height;
      .home {
        margin-top: 21%;
      }
    }
  }

  .persona {
    display: flex;
    align-items: center;
  }

  .dropdown-wrapper{
    padding: 0px 25px 0px 0px;
  }

  .el-dropdown-link {
    cursor: pointer;
    /* color: #409EFF; */
  }

.qr {
  background-color: white;
}

.re-note {
  padding-bottom: 10px;
  text-align: center;
}

.publickey {
  display: flex;
}

.copy {
  padding: 0 12px !important;
}

.qrid-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
}

.receive-container {
  width: 300px;
  height: 510px;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  box-sizing: border-box;
  z-index: 1999;
  margin: auto;
  padding: 10px;
  display: block;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(133, 133, 133);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  border-radius: 15px;
}

.receive-lock{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  z-index: 1995;
  margin: auto;
  display: block;
  background-color: #000;
  opacity: .3;
}

.avatar {
  max-width: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

  .adorable {
    width: 50%;
    border-radius: 50%;
    border: #ffffff solid 7px;
    position: absolute;
    top: -14%;
    right: 25%;
  }

.el-menu--horizontal .el-submenu>.el-menu {
  z-index: 9000;
  right: 0;
  left: unset;
  
}




</style>



// WEBPACK FOOTER //
// Header.vue?532e9c36